module.exports = __webpack_public_path__ + "img/ExitusC_quintaParte.684d0e77.png";